// extracted by mini-css-extract-plugin
export default {"element":"quicknav_element__xtY78","current":"quicknav_current__TTq2a"};